import { pushToDataLayer } from '@domain-group/fe-helper';
import { sendToMixpanel, getUserProps } from '../mixpanel';
import buildSearchProperties, {
  postcodeOf,
  stateOf,
  suburbNameOf,
} from './build-search-properties';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';
import type { Option } from '../../components/search-autocomplete/types';

export const SEARCH_BAR_TITLE = 'Find the right agent with confidence';

const joinCsv = (values: string[]): string => values.filter(Boolean).join(', ');

const asString = (value: number | string): string => (value ? `${value}` : '');

const suburbTermOf = (option: Option): string =>
  option.label
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .join(' ');

export const trackTapSearchMixpanel = (
  options: Option[],
  modules: FaaLandingPageModule[] = getVisibleLandingPageModules(),
): void => {
  const searchProperties = buildSearchProperties(options);

  if (!searchProperties) {
    return;
  }

  sendToMixpanel('Tap Search', {
    ...searchProperties,
    modules,
    modulesCount: modules.length,
    ...getUserProps(),
  });
};

export const trackTapSearchGa4 = (options: Option[]): void => {
  const searchProperties = buildSearchProperties(options);

  if (!searchProperties) {
    return;
  }

  const { searchType, agencyName } = searchProperties;
  const isSuburbSearch = searchType === 'Suburb';
  const suburbOptions = isSuburbSearch
    ? options.filter(({ category }) => category === 'Suburb')
    : [];

  const selectionOf = (): string => {
    if (searchType === 'Agent') {
      return options[0].label;
    }

    if (searchType === 'Agency') {
      return agencyName;
    }

    return '';
  };

  const searchTermOf = (): string =>
    isSuburbSearch ? joinCsv(suburbOptions.map(suburbTermOf)) : selectionOf();

  pushToDataLayer({
    event: 'search',
    event_parameters: {
      search_type: searchType,
      search_term: searchTermOf(),
      agency_agent_name: searchType === 'Agent' ? options[0].label : '',
      agency_agent_id: asString(searchProperties.agentId),
      agency_name: agencyName,
      agency_id: asString(searchProperties.agencyId),
      search_loc_category: isSuburbSearch ? 'suburb' : '',
      search_loc_state: joinCsv(suburbOptions.map(stateOf)),
      search_loc_suburb: joinCsv(suburbOptions.map(suburbNameOf)),
      search_loc_postcodes: joinCsv(suburbOptions.map(postcodeOf)),
      element_list_name: '',
      element_list_position: '',
      element_target_category_primary: '',
      element_target_page_type: '',
      element_text: selectionOf(),
      element_title: SEARCH_BAR_TITLE,
      element_type: 'search bar',
    },
  });
};

const trackTapSearch = (
  options: Option[],
  modules?: FaaLandingPageModule[],
): void => {
  trackTapSearchMixpanel(options, modules);
  trackTapSearchGa4(options);
};

export default trackTapSearch;
